import { createFileRoute, Link } from "@tanstack/react-router";
import { getDefaultStore } from "jotai";
import { RESET } from "jotai/utils";
import { z } from "zod";

import livanceLogo from "@/assets/livance-logo-secondary.svg";
import oldDoctorWithPatient from "@/assets/old-doctor-with-patient.webp";
import { Button } from "@/components/ui/button/button";
import { ImageDrawerLayout } from "@/components/ui/layout/image-drawer/image-drawer-layout";
import { firstAccessAtom } from "@/lib/atoms/first-access-atom";
import { returnToAtom } from "@/lib/atoms/return-to-atom";
import { isInternalPath } from "@/lib/utils/is-internal-path";

import type { JSX } from "react";

const LandingPage = (): JSX.Element => {
  return (
    <ImageDrawerLayout>
      <ImageDrawerLayout.Image>
        <img
          src={oldDoctorWithPatient}
          alt="Welcome illustration"
          className="object-top"
        />
      </ImageDrawerLayout.Image>

      <ImageDrawerLayout.Drawer>
        <img src={livanceLogo} alt="Logo Livance" className="h-10 self-start" />

        <ImageDrawerLayout.Content>
          <ImageDrawerLayout.Title className="text-[32px]">
            Seu consultório acontece <span className="text-primary-400">aqui</span>
          </ImageDrawerLayout.Title>
          <ImageDrawerLayout.Description>
            Tudo o que você precisa para cuidar do seu consultório com flexibilidade e
            segurança
          </ImageDrawerLayout.Description>
        </ImageDrawerLayout.Content>

        <div className="flex flex-col gap-4">
          <Link to="/auth/first-access/document" className="w-full">
            <Button fullWidth color="secondary">
              Primeiro acesso
            </Button>
          </Link>
          <Link to="/auth/signin" className="w-full">
            <Button color="secondaryLight" fullWidth>
              Acessar minha conta
            </Button>
          </Link>
        </div>
      </ImageDrawerLayout.Drawer>
    </ImageDrawerLayout>
  );
};

const landingSearch = z.object({
  returnTo: z.string().optional(),
});

export const Route = createFileRoute("/auth/landing")({
  validateSearch: landingSearch,
  beforeLoad: ({ search }) => {
    getDefaultStore().set(firstAccessAtom, RESET);

    const returnTo =
      search.returnTo && isInternalPath(search.returnTo) ? search.returnTo : null;

    getDefaultStore().set(returnToAtom, returnTo);
  },
  component: LandingPage,
});
